import { Button as MUIButton } from "@mui/material";
import { ReactNode } from "react";

interface IButton {
  type?: "button" | "submit" | "reset";
  size?: "small" | "medium" | "large";
  text: string | ReactNode;
  variant?: "text" | "contained" | "outlined";
  onClick?: (e: React.MouseEvent<HTMLButtonElement>) => void;
  className?: string;
  fullWidth?: boolean;
  isBold?: boolean;
  textTransform?: "uppercase" | "lowercase" | "capitalize" | "none";
  [key: string]: any; // Allow additional props
}

function Button({
  type = "submit",
  size = "medium",
  text,
  onClick,
  className,
  variant = "contained",
  fullWidth = true,
  textTransform = "capitalize",
  isBold = false,
  ...props
}: IButton) {
  return (
    <MUIButton
      type={type}
      size={size}
      variant={variant}
      fullWidth={fullWidth}
      onClick={onClick}
      className={`${className}`}
      style={{ textTransform }}
      {...props}
    >
      {isBold ? <b>{text}</b> : text}
    </MUIButton>
  );
}

export default Button;
